import { FormlyFieldConfig } from '@ngx-formly/core';

export function emailValidatorMessage(error: unknown, field: FormlyFieldConfig) {
  return 'Please enter a correct email format.';
}

export const onlyOneKeymanValidatorMessage = () => 'Only one person can be designated as Keyman.';

// ['CAS011', 'One of the key personnel must be an Authorised Signatory and Keyman.'],
export const mustHaveKeymanValidatorMessage = () => 'One of the key personnel must be an Authorised Signatory and Keyman.';

// ['CAS010', 'One of the key personnel must be a Sole-Proprietor.'],
export const mustHaveSoleProprietorValidatorMessage = () => 'One of the key personnel must be a Sole-Proprietor.';

// ['CAS015', 'For Pte Ltd, "at least 2 directors" or "1 director and 1 secretary" must be authorised signatory'],
export const mustHaveDirectorValidatorMessage = () =>
  'For Pte Ltd, "at least 2 directors" or "1 director and 1 secretary" must be Authorised Signatory.';

// ['CAS016', 'All key personnel must be Authorised Signatory and Shareholder'],
export const authorizedPersonnelMustHaveShareholderValidatorMessage = () =>
  'All key personnel must be Authorised Signatory and Shareholder.';

export const mustHaveAuthorisedSignatoryValidatorMessage = () => 'At least one person must be appointed as an Authorised Signatory.';

export const mustHaveShareholderValidatorMessage = () => 'Person must have shareholder Appointment.';
